/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Location,
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface LocationListBusinessDataResponse
 */
export interface LocationListBusinessDataResponse {
    /**
     * 
     * @type {number}
     * @memberof LocationListBusinessDataResponse
     */
    watermark?: number;
    /**
     * 
     * @type {Array<Location>}
     * @memberof LocationListBusinessDataResponse
     */
    businessData?: Array<Location> | null;
    /**
     * 
     * @type {number}
     * @memberof LocationListBusinessDataResponse
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationListBusinessDataResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationListBusinessDataResponse
     */
    totalRecords?: number;
}

export function LocationListBusinessDataResponseFromJSON(json: any): LocationListBusinessDataResponse {
    return LocationListBusinessDataResponseFromJSONTyped(json, false);
}

export function LocationListBusinessDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationListBusinessDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'watermark': !exists(json, 'watermark') ? undefined : json['watermark'],
        'businessData': !exists(json, 'businessData') ? undefined : (json['businessData'] === null ? null : (json['businessData'] as Array<any>).map(LocationFromJSON)),
        'pageNumber': !exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function LocationListBusinessDataResponseToJSON(value?: LocationListBusinessDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'watermark': value.watermark,
        'businessData': value.businessData === undefined ? undefined : (value.businessData === null ? null : (value.businessData as Array<any>).map(LocationToJSON)),
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'totalRecords': value.totalRecords,
    };
}


